import { AnalyticsPresensiComponent } from './analytics-presensi.component';
export default AnalyticsPresensiComponent;
